import Flex from '@deprecated-ui/common/Flex';
import ModalAntd from '@deprecated-ui/common/Modal';
import ButtonAntd from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled, { css } from 'styled-components';
import BaseGuestLayout from 'global/GuestLayout';

const OptionOTP = styled(Flex)<{ active?: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 70px;
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  margin: 8px 0;
  align-items: center;
  padding: 20px;

  :hover {
    background-color: #f7f7f7;
  }

  ${(props) =>
    props.active
      ? css`
          border-color: ${color.primary};
        `
      : css`
          border-color: ${color.downgray};
        `}
`;

const OptionOTPText = styled.div`
  margin: 0 10px;
  width: 90%;
`;

const ModalOptionOTP = styled(ModalAntd)<{ active?: boolean }>`
  .ant-modal-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }
  .ant-modal-header {
    padding: 20px 20px 16px 20px;
    border-radius: 8px 8px 0 0;
  }
  .ant-modal-body {
    padding: 0 20px 20px;
  }
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-btn-primary[disabled] {
    color: ${color.light} !important;
    background-color: ${color.hummingBird} !important;
  }
`;

const ModalConfirmation = styled(ModalOptionOTP)`
  .ant-modal-body {
    padding: 0 30px 25px;
  }
`;

const InputOTPContainer = styled.div`
  width: 24px;
  overflow: hidden;
`;

const InputOTP = styled.input`
  border: none;
  border-bottom: 1px solid rgb(218, 218, 218);
  width: 24px;
  height: 36px;
  font-size: 16px;
  text-align: center;
  padding: 0;
  outline: none;

  :focus,
  :focus-within,
  :not([value='']) {
    border-color: #00ab6b;
  }
`;

const GuestLayout = styled(BaseGuestLayout)`
  background-color: ${color.light};
  padding: 0;

  @media ${device.tablet} {
    padding: 0;
  }

  @media ${device.laptop} {
    background-color: ${color.whiteSmoke};
    padding: 0;
  }
`;

const Button = styled(ButtonAntd)`
  :disabled {
    color: ${color.light} !important;
    background-color: ${color.hummingBird} !important;
  }
`;
export {
  OptionOTP,
  ModalOptionOTP,
  OptionOTPText,
  InputOTPContainer,
  InputOTP,
  ModalConfirmation,
  GuestLayout,
  Button,
};
